

/* ========================================== Start Of Slick Slider Javascript  ========================================== */
jQuery('.brand-slider').slick({
    infinite: true,
    arrows: true,
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,

            }
        },
        {
            breakpoint: 767,
            settings: {
              
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

jQuery('.mobile-slider').slick({
    infinite: true,
    arrows: false,
    dots: true,
    slidesToShow: 2,
    mobileFirst: true, 
    responsive: [
       {
          breakpoint: 767,
          settings: "unslick"
       }
    ]
});

/* ========================================== End Of Slick Slider Javascript ========================================== */

